// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__1Efk7","pagination":"style_pagination__2Zx4F","createButton":"style_createButton__JUTf9","wrapList":"style_wrapList__1YC77"};